import React from 'react'
import ReactDOM from 'react-dom'
const RectangleChart = (props) => {
    const { bgcolor, completed, business } = props;

    const containerStyles = {
        height: 28,
        width: '75%',
        backgroundColor: "#e0e0de",
        borderRadius: 5,
        margin: "0px"
    }

    const fillerStyles = {
        height: '150%',
        width: `130%`,
        backgroundColor: bgcolor,
        borderRadius: 'inherit',
    }

    const labelStyles = {
        padding: "5px",
        marginLeft:"1px",
        color: '#fff',
        fontSize: "1.3rem",
        position: "relative",
        
    }
    const businessLabel = {
        position: "absolute",
        left: "5px",
        
    }
    const completedLabel = {
        position: "absolute",
        right: "10px",
        
    }


    return (
        <div style={containerStyles}>
            <div style={fillerStyles}>
                <div style={labelStyles}><span style={businessLabel}>{business}</span><span style={completedLabel} >{`${completed}`}</span></div>
            </div>
        </div>
    );
};

export default RectangleChart;